import { render, staticRenderFns } from "./RfxSetupConfig.vue?vue&type=template&id=fe4e78c2"
import script from "./RfxSetupConfig.vue?vue&type=script&lang=js"
export * from "./RfxSetupConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports